import React from 'react'
import {Box, Card, CardContent, Checkbox, IconButton} from '@mui/material'
import {AccountBalanceWallet, CreditCard, Edit, Repeat} from '@mui/icons-material'
import {Transaction} from '../../domain/Transaction'
import {TransactionTypeCode} from '../../domain/TransactionType'
import {AmountWithEuro} from '../AmountWithEuro'

type TransactionCardProps = {
  transaction: Transaction,
  onToggleType: () => void,
  onToggleChecked: (checked: boolean) => void,
  onEdit: () => void,
}

export const TransactionCard: React.FC<TransactionCardProps> = ({transaction, onToggleType, onToggleChecked, onEdit}) => {
  const isRecurring = !!transaction.recurrenceId
  const typeIcon = transaction.type === TransactionTypeCode.CREDIT ? <CreditCard/> : <AccountBalanceWallet/>

  return (
    <Card variant="outlined" sx={{mb: 1, backgroundColor: isRecurring ? 'grey.100' : 'white'}}>
      <CardContent sx={{display: 'flex', alignItems: 'center', gap: 1, '&:last-child': {pb: 2}}}>
        <IconButton
          data-testid="tx-card-type"
          disabled={isRecurring}
          onClick={onToggleType}
          sx={{backgroundColor: 'primary.main', color: 'white', '&:hover': {backgroundColor: 'primary.dark'}}}
        >
          {typeIcon}
        </IconButton>

        <Box
          data-testid="tx-card-body"
          onClick={onEdit}
          sx={{flex: 1, minWidth: 0, cursor: 'pointer'}}
        >
          <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5, fontWeight: 500}}>
            {transaction.description}
            {isRecurring && <Repeat fontSize="small" color="disabled"/>}
            {(transaction.amountModifications?.length ?? 0) > 0 && (
              <Edit data-testid="tx-card-modified" fontSize="small" color="action"/>
            )}
          </Box>
          <AmountWithEuro amount={transaction.amount}/>
        </Box>

        <Checkbox
          color="primary"
          checked={transaction.checked}
          onChange={(e) => onToggleChecked(e.target.checked)}
        />
      </CardContent>
    </Card>
  )
}
